module.exports = __webpack_public_path__ + "img/privileges.fd592c54.svg";